import { gql } from '@apollo/client';

export const GET_CAMPAIGNS = gql`
  query getCampaigns($campaignsFilter: CampaignsFilter!) {
    campaigns(campaignsFilter: $campaignsFilter) {
      id
      name
      startDate
      endDate
      archived
      stores {
        id
        name
      }
      tags {
        id
        name
        displayColour
        archived
      }
      users {
        id
        firstName
        lastName
      }
    }
  }
`;
